module.exports = __webpack_public_path__ + "static/img/details-bottom.ea2efb9.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/details-bottom.png
// module id = M6+R
// module chunks = 1